export function initCatering(root, state) {
    const buttons = [...root.querySelectorAll('[data-chalet-catering]')];
    state.subscribe(({priceType}) => {
        root.querySelectorAll('[data-price-type]').forEach(element => {
            element.hidden = element.dataset.priceType !== priceType;
        });
        buttons.forEach(button => {
            const selected = button.dataset.chaletCatering === priceType;
            button.setAttribute('aria-pressed', String(selected));
            button.classList.toggle('availability-price-selector__option--active', selected);
        });
    });
    buttons.forEach(button => button.addEventListener('click', () => {
        state.set({priceType: button.dataset.chaletCatering});
    }));
}
